import { Reveal } from "./Reveal";
import { Quote } from "lucide-react";

const testimonials = [
  {
    quote:
      "Omg this beef is amazing. Both my family and my son's family absolutely love the flavor, texture, and size of all the meats. We definitely will be a continued customer of yours in the future. Thank you again for everything.",
    name: "Jenica",
    span: "lg:col-span-5",
  },
  {
    quote:
      "We had T-bone steaks tonight and can't get over how good and tender this beef is!! Everything we've had has been so great! Thank you again!",
    name: "Tracie",
    span: "lg:col-span-5",
  },
  {
    quote:
      "Thank you for following up. It has been fantastic quality beef. Compliments to you and the butcher. We are very satisfied and we hope to continue to be your customer.",
    name: "Austin",
    span: "lg:col-span-5",
  },
  {
    quote:
      "My family has been purchasing beef from Mrs. Stacy for 5 years. We made the switch to grass fed beef and have never looked back. The meat is full of flavor compared to store bought of any kind, organic or not — my wife notices the color is significantly different, with a much more established marble and rich redness. She's went from LongHorn to no horn, choosing our steak over even LongHorn beef because there is so much of a difference in flavor and texture. We can always trust that the beef we get is not tampered with, injected, or miscut. You know what you're getting from beginning to end when talking with Mrs. Stacy. She has no hidden agenda — only a heart looking out for families.",
    name: "Tyler",
    span: "lg:col-span-7",
    featured: true,
  },
];

export const Testimonials = () => (
  <section className="py-24 lg:py-32 bg-white border-y border-linen" data-testid="testimonials-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <Reveal>
        <p className="text-xs tracking-[0.25em] uppercase font-bold text-clay mb-4">Testimonies</p>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight font-medium leading-tight max-w-2xl">
          What families say after the first steak.
        </h2>
      </Reveal>

      <div className="mt-16 grid grid-cols-1 lg:grid-cols-12 gap-6">
        {testimonials.map((t, i) => (
          <Reveal key={t.name} delay={i * 0.1} className={`${t.span} ${i === 1 ? "lg:mt-8" : ""}`}>
            <figure
              className={`rounded-2xl p-8 lg:p-10 h-full border transition-[transform,box-shadow] duration-200 hover:-translate-y-1 hover:shadow-lg ${
                t.featured ? "bg-forest text-cream border-forest" : "bg-cream border-linen"
              }`}
              data-testid={`testimonial-${t.name.toLowerCase()}`}
            >
              <Quote className={`w-8 h-8 ${t.featured ? "text-clay" : "text-clay/70"}`} strokeWidth={1.5} />
              <blockquote className={`font-display italic text-xl sm:text-2xl leading-relaxed mt-5 ${t.featured ? "text-cream/95" : "text-forest/90"}`}>
                "{t.quote}"
              </blockquote>
              <figcaption className={`mt-6 text-sm font-bold tracking-[0.2em] uppercase ${t.featured ? "text-clay" : "text-clay"}`}>
                — {t.name}
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
